const StartPage = ({ children, title }) => {
  return (
    <div
      style={{
        backgroundImage: `url(/assets/images/loginBG.png)`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        height: "130vh",
      }}
    >
      <div className="container-fluid start_page h-100">
        <div className="row">
          <div className="col-md-12">
            <div className="row d-flex justify-content-center">
              <div
                className="col-xl-4 col-lg-6"
                style={{
                  backgroundColor: "rgb(255 255 255 / 60%)",
                  borderRadius: 10,
                  height: "100%",
                }}
              >
                <div className="justify-content-center d-flex  mb-4">
                  <img
                    src="/assets/images/idsclogo.png"
                    style={{ width: "50%" }}
                    // className="rounded-circle"
                    alt=""
                  />
                </div>
                <h4
                  className="text-center px-2 mb-5"
                  style={{ lineHeight: "40px" }}
                >
                  <div className="text-center px-2 mb-1">
                    رئاسة مجلس الوزراء
                  </div>
                  <div className="text-center px-2 mb-1">
                    {" "}
                    مركز المعلومات ودعم اتخاذ القرار
                  </div>
                </h4>
                <h5 className="text-center ">{title} </h5>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StartPage;
